import { render, staticRenderFns } from "./formMOdel.vue?vue&type=template&id=b422f694&scoped=true"
import script from "./formMOdel.vue?vue&type=script&lang=js"
export * from "./formMOdel.vue?vue&type=script&lang=js"
import style0 from "./formMOdel.vue?vue&type=style&index=0&id=b422f694&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b422f694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b422f694')) {
      api.createRecord('b422f694', component.options)
    } else {
      api.reload('b422f694', component.options)
    }
    module.hot.accept("./formMOdel.vue?vue&type=template&id=b422f694&scoped=true", function () {
      api.rerender('b422f694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/socialComponent/formMOdel.vue"
export default component.exports